import React from "react";
import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";
import Router from "next/router";

import { USER_ROLES } from "constants/index";

import { selectIsUserFetched, selectUserRoles } from "store/user/account/selectors";

export default function RequireUmbrellaAuth(ComposedComponent) {
    const AuthenticateUmbrella = ({ isUserFetched, userRoles }) => {
        const isUserUmbrella = userRoles?.find?.((e) => e == USER_ROLES.UMBRELLA);
        React.useEffect(() => {
            if (isUserFetched && !isUserUmbrella) Router.push("/dashboard");
        }, [isUserFetched, isUserUmbrella]);

        if (!isUserUmbrella || !isUserFetched) return null;

        return <ComposedComponent />;
    };

    const mapStateToProps = createStructuredSelector({
        userRoles: selectUserRoles,
        isUserFetched: selectIsUserFetched,
    });
    return connect(mapStateToProps)(AuthenticateUmbrella);
}
